import {connection} from "./jsstore_con";
import Vue from "@/main";
import store from "@/store/store.js"
import {ChatTicketService} from "@/db/chatTicket_service";
import {OrderByMsgService} from "@/db/orderByMsg_service";
import {CustomerChatReactionsService} from "./customerChatReactions_service";

export class CustomerChatService {
    constructor() {
        this.tableName  = "CustomerChats";
        this.ctService  = new ChatTicketService();
        this.ordService = new OrderByMsgService();
        this.ccrService = new CustomerChatReactionsService();
    }

    getAll() {
        return connection.select({
            from: this.tableName
        });
    }

    async getChatByCustomer(customer, instance, limit) {
        let chats = await connection.select({
            from: this.tableName,
            where: {
                instance_id: instance,
                customer_id: customer
            },
            order: [
                {
                    by: 'sent_at',
                    type: 'desc',
                    idbSorting: false
                },
                {
                    by: 'id',
                    type: 'desc',
                    idbSorting: false
                }
            ],
            limit: limit
        });

        if ( chats.length > 0 ){
            const reactions = await this.ccrService.getByWhere({
                customer_chat_id: { in: (chats.map(chat => chat.id)) }
            });

            return chats.map(chat => {
                chat.reactions = reactions.filter(reaction => reaction.customer_chat_id === chat.id);
                return chat;
            });
        }

        return chats;
    }

    async insert(values, updateUnseen = false, refresh = false, refreshSelected = false, updateLastMsg = true, sock = false) {
        if ( values[0] !== undefined && !store.getters["instance/chosenInstanceIds"].includes(values[0].instance_id) ) {
            return;
        }

        if (values[0] !== undefined && values[0].replyMessageId !== undefined && values[0].replyMessageId !== null) {
            let origMessage = await connection.select({
                from: this.tableName,
                where: {
                    id: values[0].replyMessageId
                }
            })
            values[0].parentCustomerChat = origMessage[0];
        }

        values.forEach(item => {
            if ( item.customerChatReactions && item.customerChatReactions.length > 0 ) {
                this.ccrService.insert(item.customerChatReactions)
            }
            delete item.customerChatReactions
        })

        let inserted = await connection.insert({
            into: this.tableName,
            values: values,
            upsert: true
        });

        if (updateLastMsg) {
            for (let i = 0; i < values.length; i++) {
                if (values[i].chat_ticket_id !== undefined && values[i].chat_ticket_id !== null) {
                    await this.ctService.updateLastMsg(values[i], sock);
                }
            }
        }

        if (updateUnseen && values[0].type === 1) {
            if (values[0].chat_ticket_id !== undefined && values[0].chat_ticket_id !== null) {
                Vue.$events.fire('ChangeUnseenMsg', values[0]);
            }
        }

        if (inserted > 0 && refresh) {
            Vue.$events.fire('RefreshObserverChatData', values[0]);
            Vue.$events.fire('RefreshQueryObservable', false);
        }
        if (inserted> 0 && refreshSelected) {
            Vue.$events.fire('RefreshObserverChatData', values[0]);
        }
        if (inserted > 0) {
            if (
                values[0].type === 0
                && (
                    values[0].hash !== null
                    && values[0].hash !== undefined
                    && values[0].hash.search('start') >= 0
                )
                && values[0].ack === null
                && values[0].is_temp === undefined
            ) {
                Vue.$events.fire('RefreshQueryObservable', false);
                // Vue.$events.fire('ResetActiveUser');
            }
        }
        return inserted > 0 ? inserted : null;
    }

    async removeInsert(values, sock = false) {
        if ( store.getters["instance/chosenInstanceIds"].includes(values.instance_id) ) {
            let remove = await connection.remove({
                from: this.tableName,
                where: {
                    hash: values.hash
                }
            });

            let message = values.message;
            if (!!values.tag_type && values.tag_type === 'audio' || values.tag_type === 'ptt') {
                if (message.includes('?GoogleAccessId')) {
                    message = message.slice(0, message.indexOf('?GoogleAccessId='));
                    try {
                        remove = await connection.remove({
                            from: this.tableName,
                            where: {
                                customer_id: values.customer_id,
                                instance_id: values.instance_id,
                                message: {like: `%${message}%` },
                                is_temp: 1
                            }
                        });
                    } catch (e) { console.error(e) }
                }
            }

            if (remove === 0) {
                remove = await connection.select({
                    from: this.tableName,
                    where: {
                        customer_id: values.customer_id,
                        instance_id: values.instance_id,
                        message: values.message,
                        is_temp: 1
                    }
                });

                for (const messageTemp of remove) {
                    await connection.remove({
                        from: this.tableName,
                        where: {
                            hash: messageTemp.hash
                        }
                    });
                    Vue.$events.fire('DeleteJobReceivedMessage', messageTemp.hash);
                }
            }

            if (values.hash.search('start') >= 0) {
                // Vue.$events.fire('ResetActiveUser');
                Vue.$events.fire('CallAPI', 'my_chats')
            }
            await this.insert([values], true, true, false, true, sock)
        }
    }

    async getLastMessage(customerId, instanceId, object = false) {
        try {
            let res = await connection.select({
                from: this.tableName, 
                where: {
                    customer_id: customerId,
                    instance_id: instanceId
                },
                order: [
                    {
                        by: 'sent_at',
                        type: 'desc',
                        idbSorting: false
                    },
                    {
                        by: 'id',
                        type: 'desc',
                        idbSorting: false
                    }
                ],
                limit: 1
            })

            if (object){
                return res[0] !== undefined
                  ? res[0]
                  : null;
            }

            return res[0].id !== undefined
              ? res[0].id
              : 0;
        } catch (e) {
            return 0;
        }
    }

    async updateAckCustomerChat(value) {
        await connection.update({
            in: this.tableName,
            set: {
                ack: value.ack
            },
            where: {
                hash: value.hash
            }
        });
    }

    async update(value, isFanout = false) {
        if (isFanout && value[0].customerChatId !== undefined && value[0].customerChatId !== null) {
            const updated = await connection.update({
                in: this.tableName,
                where: {
                    id: value[0].customerChatId
                },
                set: {
                    message: value[0].pusherData.message,
                    tag_type: value[0].pusherData.tag_type,
                    is_edited: value[0].pusherData.is_edited
                }
            });

            if (updated > 0){
                let res = await connection.select({
                    from: this.tableName,
                    where: {
                        id: value[0].customerChatId
                    }
                });

                await this.ctService.updateLastMsg(res[0])
                Vue.$events.fire('RefreshObserverChatData', res[0]);
                Vue.$events.fire('RefreshQueryObservable', false);
            }
        }
    }

    async clearTable(instanceIds, ticketIds = []) {
        await this.ccrService.clearTable(instanceIds, ticketIds);
        await this.ordService.clearTable(instanceIds, ticketIds);

        const where = ticketIds && ticketIds.length > 0 ? { chat_ticket_id: { in: ticketIds }} : { instance_id: { in: instanceIds }};
        await connection.remove({
            from: this.tableName,
            where: where
        })
    }

    async getMessageByText({searchQuery, customerId, instanceId}) {
        try {
            return await connection.select({
                from: this.tableName,
                where: {
                    instance_id: instanceId,
                    customer_id: customerId,
                    message: {
                        like: `%${searchQuery}%`
                    },
                },
                order: {
                    by: 'id',
                    type: 'desc',
                    idbSorting: false
                },
            });
        } catch (e) {
            return [];
        }
    }

    async getMessageByDate(date, customerId, instanceId) {
        return await connection.select({
            from: this.tableName,
            limit: 1,
            order: {
                by: 'id',
                type: 'desc',
                idbSorting: false
            },
            where: [
                {
                    instance_id: instanceId,
                    customer_id: customerId,
                    sent_at: {
                        like: `${date}%`
                    }
                },
                {
                    tag_type: {
                        '!=': 'comment'
                    }
                }
            ]
        });
    }
}